
import { useContext } from "react";
import "./Advantages.scss";
import { PopupContext } from "./PopupProvider";


function Advantages({ columns }) {
  const { openPopup } = useContext(PopupContext)
  return (
    <section className="position-relative">
      <div className="container p-0">
        <div className="d-flex advantages__row">
          {columns.map((i) => (
            <div
              style={{
                background: 'white',
                overflow: 'hidden',
                boxShadow: '1px 1px 5px  #00000030',
                borderRadius: '20px'
              }}
              className="    advantages__columns p-0  advantage_item"
              onClick={() => openPopup(i.id)}
              key={i.id}
            >
              <div className="advantages__img" style={{ width: "100%", background: '#f26e59' }}>
                <img

                  style={{}}
                  src={i.image}
                  alt="сетка из квадратов белого цвета, на них еще несколько блоков квадрата в произвольной последовательности "
                />
              </div>

              <div className="p-3">
                <h6 className="mt-3 mb-4" style={{ fontSize: "1.2rem" }}>
                  {i.title}
                </h6>
                <p style={{ color: "#00000095", }}>{i.paragraph}</p>
              </div>

            </div>
          ))}
        </div>
      </div>

    </section>
  );
}

export default Advantages;
